/**
 * @generated SignedSource<<7796a24313439b0ca9809973df2f7045>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WooviPayButtonApp_charge$data = {
  readonly id: string;
  readonly metaPixel: {
    readonly token: string | null | undefined;
  } | null | undefined;
  readonly status: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Payment_charge" | "useMeta_charge">;
  readonly " $fragmentType": "WooviPayButtonApp_charge";
};
export type WooviPayButtonApp_charge$key = {
  readonly " $data"?: WooviPayButtonApp_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"WooviPayButtonApp_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationMetaPixel",
  "kind": "LinkedField",
  "name": "metaPixel",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WooviPayButtonApp_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Payment_charge"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeta_charge",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "identifier",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    (v0/*: any*/),
    (v1/*: any*/)
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "b3ba6190311e3000eb4b0cac7aa3d2b1";

export default node;
